import React from 'react';
import { Box, Grid, Typography, Card, CardContent, useTheme, alpha } from '@mui/material';
import SectionContainer from './SectionContainer';
import AnimatedElement from './AnimatedElement';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import MoneyOffOutlinedIcon from '@mui/icons-material/MoneyOffOutlined';
import AccountCircleOffOutlinedIcon from '@mui/icons-material/PersonOutline';

const ProblemCard = ({ icon, title, description, animation = 'fadeInUp', delay = 0 }) => {
  const theme = useTheme();
  
  return (
    <AnimatedElement animation={animation} delay={delay}>
      <Card
        elevation={0}
        sx={{
          height: '100%',
          borderRadius: 4,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
            transform: 'translateY(-8px)',
            borderColor: theme.palette.secondary.main,
          },
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              mb: 3,
              color: theme.palette.primary.main,
            }}
          >
            {icon}
          </Box>
          <Typography variant="h5" component="h3" gutterBottom fontWeight="bold">
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </Card>
    </AnimatedElement>
  );
};

const ProblemSection = () => {
  const theme = useTheme();

  const problems = [
    {
      icon: <PeopleAltOutlinedIcon sx={{ fontSize: 40 }} />,
      title: 'Низкая доходимость до вебинара',
      description: 'Пользователи не хотят покидать Telegram и переходить в браузер. На этом шаге теряется до 20% потенциальных участников.',
      delay: 0.2,
    },
    {
      icon: <ErrorOutlineOutlinedIcon sx={{ fontSize: 40 }} />,
      title: 'Сложно отследить участников',
      description: 'Организаторы не могут достоверно определить, кто из приглашённых действительно посетил вебинар.',
      delay: 0.4,
    },
    {
      icon: <AccountCircleOffOutlinedIcon sx={{ fontSize: 40 }} />,
      title: 'Фейковые контактные данные',
      description: 'Перед входом на вебинар зрители вводят вымышленные имена и контакты, что затрудняет последующее взаимодействие.',
      delay: 0.6,
    },
    {
      icon: <MoneyOffOutlinedIcon sx={{ fontSize: 40 }} />,
      title: 'Дорогое привлечение аудитории',
      description: 'Привлечение каждого зрителя обходится в среднем в 500 рублей, а потери участников негативно влияют на ROI вебинара.',
      delay: 0.8,
    },
  ];

  return (
    <SectionContainer
      id="problem"
      title="Проблемы продающих вебинаров"
      subtitle="Сегодня большинство инфо-продуктов продаются через чаты и каналы в Telegram, но существующие вебинарные платформы не справляются с задачей"
      bgColor={alpha(theme.palette.primary.main, 0.03)}
    >
      <Box sx={{ position: 'relative' }}>
        <Grid container spacing={3}>
          {problems.map((problem, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <ProblemCard
                icon={problem.icon}
                title={problem.title}
                description={problem.description}
                delay={problem.delay}
              />
            </Grid>
          ))}
        </Grid>
        
        <AnimatedElement animation="fadeIn" delay={1}>
          <Box sx={{ mt: 8, p: 4, bgcolor: alpha(theme.palette.error.main, 0.08), borderRadius: 4 }}>
            <Typography variant="h6" color="error.dark" fontWeight="medium" align="center">
              Обычные платформы для вебинаров, такие как Zoom или Яндекс Телемост, не предоставляют инструментов для продающих вебинаров: настройку сценариев появления призывов к действию и интеграцию с мессенджерами
            </Typography>
          </Box>
        </AnimatedElement>
      </Box>
    </SectionContainer>
  );
};

export default ProblemSection; 